const mainContainer = document.querySelector(".ing-main");

if (!mainContainer) return;

const intSlider = setInterval(function () {
	const swiperContainer = mainContainer.querySelector("swiper-container");
	if (!swiperContainer) {
		const mainSliderPdp = document.querySelector(
			".main-slider-pdp .tagshop-socialwall"
		);
		if (mainSliderPdp) {
			mainContainer.innerHTML = mainSliderPdp.innerHTML;
			initializeSwiperSlides();
			clearInterval(intSlider);
			console.log("Swiper initialized");
		}
	} else {
		console.log("Swiper already exists");
	}
}, 200);


function initializeSwiperSlides() {
	const slides = mainContainer.querySelectorAll(
		"swiper-slide .ts_ms_post_wrapper"
	);
	slides.forEach((slide) => {
		slide.addEventListener("click", function () {
			const id = this.id;
			document.getElementById(id)?.click();
		});
	});
}

window.addEventListener("load", function () {
	eraseCookie("sliderSlug");
});


function openChooseSize(el) {
	el.closest(".product-packaged")?.classList.add("open-size");
}


setInterval(function () {
	const pos = window.mainSlider?.getPos();
	if (pos === undefined) return;

	const pdp = document.querySelector(`.product-packaged[data-index="0"]`);
	if (!pdp) return;

	const beforeElement = pdp.querySelector("[data-before]");   
	if (beforeElement?.dataset.before) {
		const slug = pdp.getAttribute("data-slug");
		const slugCookie = getCookie("sliderSlug");
        console.log(slugCookie, slug);
		if (slug && slug !== slugCookie) {
			const noti = pdp.querySelector(".arrow-product-gallery");
			if (noti) {
				noti.style.visibility = "visible";
				setCookie("sliderSlug", slug, 0.1);
				setTimeout(() => {
					noti.style.visibility = "hidden";
					noti.setAttribute("data-show", "1");
				}, 1000);
			}
		}
	}
}, 2000);
